//* ---------------- GARMENTS ---------------- *//
export class GarmentStatus {
  static INCOMPLETE = 'Incomplete' as const
  static CMT_FABRIC_HOLD = 'CMT Fabric Hold' as const
  static FABRIC_HOLD = 'Fabric Hold' as const
  static FABHOLD = 'Fabric Hold' as const
  static READY = 'Ready' as const
  static BLUE_PENCIL = 'Blue Pencil' as const
  static PREP = 'Blue Pencil' as const
  static CUTTING = 'Cutting' as const
  static PRODUCTION = 'Production' as const
  static PRODUCTION_COMPLETE = 'Production Complete' as const
  static INTERNATIONAL_TRANSIT = 'International Transit' as const
  static FINAL_INSPECTION = 'Final Inspection' as const
  static SHIPMENT_PROCESSING = 'Shipment Processing' as const
  static DELIVERY = 'Delivery' as const
  static DIRECT_SHIP = 'Direct Ship' as const
  static CANCELED = 'Canceled' as const
  static VALID = [
    this.INCOMPLETE,
    this.CMT_FABRIC_HOLD,
    this.FABRIC_HOLD,
    this.READY,
    this.BLUE_PENCIL,
    this.CUTTING,
    this.PRODUCTION,
    this.PRODUCTION_COMPLETE,
    this.INTERNATIONAL_TRANSIT,
    this.FINAL_INSPECTION,
    this.SHIPMENT_PROCESSING,
    this.DELIVERY,
    this.DIRECT_SHIP,
    this.CANCELED,
  ] as const
  static EDITABLE = [this.FABRIC_HOLD, this.CMT_FABRIC_HOLD, this.READY] as const
  static DELIVERABLE = [this.DELIVERY, this.DIRECT_SHIP] as const
  static NOT_OVERNIGHTABLE = [this.DELIVERY, this.DIRECT_SHIP] as const
}

export const GarmentStatusById = {
  1: GarmentStatus.INCOMPLETE,
  3: GarmentStatus.READY,
  4: GarmentStatus.PREP,
  5: GarmentStatus.PRODUCTION,
  6: GarmentStatus.PRODUCTION_COMPLETE,
  7: GarmentStatus.INTERNATIONAL_TRANSIT,
  8: GarmentStatus.FINAL_INSPECTION,
  9: GarmentStatus.DELIVERY,
  10: GarmentStatus.FABRIC_HOLD,
  11: GarmentStatus.SHIPMENT_PROCESSING,
  12: GarmentStatus.DIRECT_SHIP,
  13: GarmentStatus.CUTTING,
  20: GarmentStatus.CANCELED,
  21: GarmentStatus.CMT_FABRIC_HOLD,
}

//* ---------------- FABRIC ORDERS ---------------- *//
export class FabricOrderStatus {
  static ACCEPTED = 'accepted' as const
  static CANCELLED = 'cancelled' as const
  static PACKING = 'packing' as const
  static PENDING = 'pending' as const
  static RECEIVED = 'received' as const
  static REJECTED = 'rejected' as const
  static TRANSIT = 'transit' as const
  static VALID = [
    this.ACCEPTED,
    this.CANCELLED,
    this.PACKING,
    this.PENDING,
    this.RECEIVED,
    this.REJECTED,
    this.TRANSIT,
  ] as const
}

//* ---------------- FABRICS ---------------- *//
export const IN_STOCK = 'inStock'
export const TEMP_OUT = 'tempOut'
export const UNAVAILABLE = 'unavailable'

//* ---------------- SHIPMENTS ---------------- *//
export class Shipment {
  static Status = class {
    static PENDING = 'pending' as const
    static TRANSIT = 'transit' as const
    static RECEIVED = 'received' as const
    static VALID = [this.PENDING, this.TRANSIT, this.RECEIVED] as const
  }

  static Type = class {
    static GARMENT_ORDER = 'garment order' as const
    static FABRIC_ORDER = 'fabric order' as const
    static DEALER_ORDER = 'dealer order' as const
    static DIRECT_SHIP = 'direct ship' as const
    static BOLT_ORDER = 'bolt order' as const
    static VALID = [
      this.GARMENT_ORDER,
      this.FABRIC_ORDER,
      this.DEALER_ORDER,
      this.DIRECT_SHIP,
      this.BOLT_ORDER,
    ] as const
  }
}

//* ---------------- DELAYS ---------------- *//
export class GarmentDelayStatus {
  static OK = 'Not Delayed' as const
  static FABRIC_OUT = 'Fabric Out' as const
  static FABRIC_RECEIPT = 'Fabric Receipt Delay' as const
  static FABRIC_DAMAGED = 'Fabric Flawed/Damaged' as const
  static FABRIC_SHORT = 'Fabric Short' as const
  static DEALER_INSTRUCT = 'Dealer Instruction Required' as const
  static GARMENT_DAMAGED = 'Garment Damaged Delay' as const
  static TRINITY_REVIEW = 'Trinity Review' as const
  static DEALER_HOLD = 'Dealer Hold' as const
  static CMT_SHELL = 'CMT Shell Fabric Delay' as const
  static CMT_LINING = 'CMT Lining Fabric Delay' as const
  static CMT_TRIM = 'CMT Trim Fabric Delay' as const
  static PATTERN_REVIEW = 'Pattern Review' as const
  static FACTORY_REVIEW = 'Factory Review' as const
}

export const DelayStatusById = {
  1: GarmentDelayStatus.OK,
  2: GarmentDelayStatus.FABRIC_OUT,
  4: GarmentDelayStatus.FABRIC_DAMAGED,
  5: GarmentDelayStatus.FABRIC_SHORT,
  6: GarmentDelayStatus.DEALER_INSTRUCT,
  7: GarmentDelayStatus.GARMENT_DAMAGED,
  8: GarmentDelayStatus.TRINITY_REVIEW,
  9: GarmentDelayStatus.DEALER_HOLD,
  10: GarmentDelayStatus.CMT_SHELL,
  11: GarmentDelayStatus.CMT_LINING,
  12: GarmentDelayStatus.CMT_TRIM,
  13: GarmentDelayStatus.PATTERN_REVIEW,
  14: GarmentDelayStatus.FACTORY_REVIEW,
}

//* ----------- Typescript Shenanigans ----------- *//
/** Use when needing to typecast a GarmentStatus array for something like .includes */
export type GarmentStatusArrayType = ReadonlyArray<string>
